import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  link: {
    color: theme.palette.text.primary,
  },
  error: {
    color: theme.palette.error.main,
  },
}))

export default styles
